module.exports = __webpack_public_path__ + "img/network.50af6c57.svg";